import type { TFunction } from 'i18next';

import { NamedRole } from '@/shared/types/role';

import { ADMIN, BILLING, BUILDER, CHAT_AGENT, CHAT_MANAGER } from './constants';

/**
 * Locale keys for the system roles, in display order. Spelled out rather than built from
 * the role id because `t()` keys have to stay greppable. Reader and Writer are legacy
 * roles we no longer surface, so leaving them out also filters them from the list.
 */
export const SYSTEM_ROLE_COPY: Record<string, { name: string; description: string }> = {
  [CHAT_AGENT]: {
    name: 'roles.facade00-0000-4000-a000-000000000005.name',
    description: 'roles.facade00-0000-4000-a000-000000000005.description',
  },
  [CHAT_MANAGER]: {
    name: 'roles.facade00-0000-4000-a000-000000000006.name',
    description: 'roles.facade00-0000-4000-a000-000000000006.description',
  },
  [BUILDER]: {
    name: 'roles.facade00-0000-4000-a000-000000000004.name',
    description: 'roles.facade00-0000-4000-a000-000000000004.description',
  },
  [ADMIN]: {
    name: 'roles.facade00-0000-4000-a000-000000000003.name',
    description: 'roles.facade00-0000-4000-a000-000000000003.description',
  },
  [BILLING]: {
    name: 'roles.facade00-0000-4000-a000-000000000008.name',
    description: 'roles.facade00-0000-4000-a000-000000000008.description',
  },
};

export const SYSTEM_ROLE_ORDER = Object.keys(SYSTEM_ROLE_COPY);

export const roleDisplayName = (role: NamedRole, t: TFunction) => {
  const copy = SYSTEM_ROLE_COPY[role.role_id];
  if (!copy) {
    return role.name;
  }
  if (!role.name) {
    return t(copy.name);
  }
  return t(copy.name, { defaultValue: role.name });
};

export const roleDisplayDescription = (role: NamedRole, t: TFunction) => {
  const copy = SYSTEM_ROLE_COPY[role.role_id];
  return copy ? t(copy.description) : '';
};
